export let questionStatus = [
  {
    label: '待回答',
    value: 'UNANSWERED'
  },
  {
    value: 'ANSWERED',
    label: '已回答'
  },
  {
    value: 'CLOSED',
    label: '已关闭'
  }
]
// 判断问答类型
export let askAnswerTypes = {
  'ANSWER': '回答',
  'ASK': '提问'
}
